export const GET_SAVS = "GET_SAVS";
export const GET_SAVS_COMPLETED = "GET_SAVS_COMPLETED";
export const GET_SAVS_FAILED = "GET_SAVS_FAILED";

export const GET_SAV = "GET_SAV";
export const GET_SAV_COMPLETED = "GET_SAV_COMPLETED";
export const GET_SAV_FAILED = "GET_SAV_FAILED";

export const GET_SAV_CONSTANTS = "GET_SAV_CONSTANTS";
export const GET_SAV_CONSTANTS_COMPLETED = "GET_SAV_CONSTANTS_COMPLETED";
export const GET_SAV_CONSTANTS_FAILED = "GET_SAV_CONSTANTS_FAILED";

export const GET_SAV_EN_COURS = "GET_SAV_EN_COURS";
export const GET_SAV_EN_COURS_COMPLETED = "GET_SAV_EN_COURS_COMPLETED";
export const GET_SAV_EN_COURS_FAILED = "GET_SAV_EN_COURS_FAILED";

export const CREATE_SAV = "CREATE_SAV";
export const UPDATE_SAV = "UPDATE_SAV";
export const PATCH_SAV_STATUT = "PATCH_SAV_STATUT";
export const PATCH_SAV_JALON = "PATCH_SAV_JALON";
export const PATCH_SAV_RATTACHER = "PATCH_SAV_RATTACHER";
export const SEARCH_SAV_RATTACHEMENT = "SEARCH_SAV_RATTACHEMENT";
export const GET_SAV_BAREME = "GET_SAV_BAREME";
export const GET_SAV_CARTE = "GET_SAV_CARTE";

// Historique SAV complet d'un client (réglés inclus) pour la fiche client.
// Type dédié : le reducer ne le capte pas (n'écrase pas la liste du board).
export const GET_SAV_HISTORY = "GET_SAV_HISTORY";

export const getClientSavHistory = ({ clientId, entrepriseId } = {}) => {
  const params = {};
  if (clientId) params.client_id = clientId;
  if (entrepriseId) params.entreprise_id = entrepriseId;
  return {
    type: GET_SAV_HISTORY,
    meta: {
      async: true,
      blocking: true,
      path: `/api/sav-b2b.json`,
      method: "GET",
      params,
    },
  };
};

// Liste / historique — filtres : statut, non_regle, charge_de_clientele,
// commande_groupee_id, client_id, entreprise_id
export const getSav = (id) => ({
  type: GET_SAV,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}.json`,
    method: "GET",
    params: {},
  },
});

export const getSavs = (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters || {}).filter(([, v]) => v !== null && v !== undefined && v !== "")
  );
  return {
    type: GET_SAVS,
    meta: {
      async: true,
      blocking: false,
      path: `/api/sav-b2b.json`,
      method: "GET",
      params,
    },
  };
};

export const getSavConstants = () => ({
  type: GET_SAV_CONSTANTS,
  meta: {
    async: true,
    blocking: false,
    path: `/api/sav-b2b/constants.json`,
    method: "GET",
    params: {},
  },
});

// SAV non réglés d'un client / d'une entreprise (bannière prochaine prestation)
export const getSavEnCours = (clientId, entrepriseId) => {
  const params = {};
  if (clientId) params.client_id = clientId;
  if (entrepriseId) params.entreprise_id = entrepriseId;
  return {
    type: GET_SAV_EN_COURS,
    meta: {
      async: true,
      blocking: false,
      path: `/api/sav-b2b/en-cours.json`,
      method: "GET",
      params,
    },
  };
};

export const createSav = (data) => ({
  type: CREATE_SAV,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b.json`,
    method: "POST",
    body: data,
  },
});

export const ADD_SAV_NOTE = "ADD_SAV_NOTE";

// Fil de commentaires du SAV : chaque commentaire s'empile côté API et le champ
// de saisie se libère pour le suivant (retour Camille 17/09).
export const addSavNote = (id, contenu) => ({
  type: ADD_SAV_NOTE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/note.json`,
    method: "POST",
    body: { contenu },
  },
});

export const updateSav = (id, data) => ({
  type: UPDATE_SAV,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}.json`,
    method: "PUT",
    body: data,
  },
});

// Workflow A_TRAITER → EN_COURS → REGLE (pilote le blocage facturation)
export const patchSavStatut = (id, statut) => ({
  type: PATCH_SAV_STATUT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/statut.json`,
    method: "PUT",
    body: { statut: statut },
  },
});

export const patchSavJalon = (id, jalon) => ({
  type: PATCH_SAV_JALON,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/jalon.json`,
    method: "PUT",
    body: { jalon: jalon },
  },
});

export const patchSavRattacher = (id, payload) => ({
  type: PATCH_SAV_RATTACHER,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/rattacher.json`,
    method: "PUT",
    body: payload,
  },
});

export const searchSavRattachement = (q) => ({
  type: SEARCH_SAV_RATTACHEMENT,
  meta: {
    async: true,
    blocking: false,
    path: `/api/sav-b2b/recherche-rattachement.json`,
    method: "GET",
    params: { q, limit: 20 },
  },
});

export const getSavBareme = (id) => ({
  type: GET_SAV_BAREME,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/bareme.json`,
    method: "GET",
    params: {},
  },
});

export const getSavCarte = (id) => ({
  type: GET_SAV_CARTE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/sav-b2b/${id}/carte.json`,
    method: "GET",
    params: {},
  },
});
